module.exports = __webpack_public_path__ + "img/img1.95c83938.png";